/*eslint-disable */
import moment from 'moment';
import root from '../_helpers/roots';
import Vue from 'vue'
import router from '../route';
import toast from '../services/toast';
import axios from 'axios';
let quizContestListLinkUrl = root.quizContestListLink.link;
let helpPageURL = root.helpPageUrl.link;
let contestPointObtainedURL = root.contestPointObtainedUrl.link;
let contestLeaderBoardURL = root.contestLeaderBoardUrl.link;
let userContestFeedbackURL = root.userContestFeedbackUrl.link;
let schoolLeaderBoardURL = root.schoolLeaderBoardUrl.link;
let quizWinnerLink = root.quizWinnerLink.link;
let orgLeaderBoardURL = root.orgLeaderListLink.link;
export default {
    state: {
        quizContestState: {},
        contestPointsObtainedState:{},
        contestLeaderBoardState:{},
        schoolLeaderBoardState:{},
        orgLeaderBoardState:{},
        quizWinnerState: {}
    },
    mutations: {
        quizWinnerMutation(state, value) {
          state.quizWinnerState = value;
        },
        quizContestMutation(state, value){
          state.quizContestState = value;
        },
        contestPointsObtainedMutation(state, value){
          state.contestPointsObtainedState = value;
        },
        contestLeaderBoardMutation(state, value){
          state.contestLeaderBoardState = value;
        },
        schoolLeaderBoardMutation(state, value){
          state.schoolLeaderBoardState = value;
        },
        orgLeaderBoardMutation(state, value){
          state.orgLeaderBoardState = value;
        }
    },
    actions: {
      getQuizWinnersListFun(context, payload) {
        return new Promise((resolve, reject) => {
          axios.get(quizWinnerLink + payload.id + '/leaderboard/')
            .then(function(response) {
              context.commit('quizWinnerMutation', response.data);
              resolve(response.data);
            })
            .catch(
              function(err) {
                reject(err);
              }
            )
        })
      },
        getQuizContestListFun(context, payload) {
          return new Promise((resolve, reject) => {
            axios.get(quizContestListLinkUrl + '?user_local_date=' + moment.utc().format())
              .then(function(response) {
                context.commit('quizContestMutation', response.data);
                resolve(response.data);
              })
              .catch(
                function(err) {
                  reject(err);
                }
              )
          })
        },
        getQuizContestFun(context, payload) {
          return new Promise((resolve, reject) => {
            axios.get(quizContestListLinkUrl + '?user_local_date=' + moment.utc().format())
              .then(function(response) {
                resolve(response.data);
              })
              .catch(
                function(err) {
                  reject(err);
                }
              )
          })
        },
        getQuizContestForTestingListFun(context, payload) {
          return new Promise((resolve, reject) => {
            axios.get(quizContestListLinkUrl + '?user_local_date=' + moment.utc().format() + '&testing_enabled=' + payload.id)
              .then(function(response) {
                if (response.status == '400' || response.status == '403') {
                  router.push('/contest/')
                }else{
                  context.commit('quizContestMutation', response.data);
                  resolve(response.data);
                }
              })
              .catch(
                function(err) {
                  reject(err);
                }
              )
          })
        },
        helpRequestFun(context, payload) {
          return new Promise((resolve, reject) => {
            axios.post(helpPageURL, payload)
              .then(function(response) {
                resolve(response.data);
              })
              .catch(
                function(err) {
                  reject(err);
                }
              )
          })
        },
        getContestPointsObtainedFun(context, payload) {
          return new Promise((resolve, reject) => {
            axios.get(contestPointObtainedURL)
              .then(function(response) {
                context.commit('contestPointsObtainedMutation', response.data);
                resolve(response.data);
              })
              .catch(
                function(err) {
                  reject(err);
                }
              )
          })
        },
        getContestLeaderBoardListFun(context, payload) {
          return new Promise((resolve, reject) => {
            axios.get(contestLeaderBoardURL)
              .then(function(response) {
                context.commit('contestLeaderBoardMutation', response.data);
                resolve(response.data);
              })
              .catch(
                function(err) {
                  reject(err);
                }
              )
          })
        },
        createdFeedbackOfContestFun(context, payload) {
          return new Promise((resolve, reject) => {
            axios.post(userContestFeedbackURL, payload)
              .then(function(response) {
                resolve(response.data);
              })
              .catch(
                function(err) {
                  reject(err);
                }
              )
          })
        },
        getSchoolLeaderBoardListFun(context, payload) {
          return new Promise((resolve, reject) => {
            axios.get(schoolLeaderBoardURL)
              .then(function(response) {
                context.commit('schoolLeaderBoardMutation', response.data);
                resolve(response.data);
              })
              .catch(
                function(err) {
                  reject(err);
                }
              )
          })
        },
        getOrgLeaderBoardListFun(context, payload) {
          return new Promise((resolve, reject) => {
            axios.get(orgLeaderBoardURL)
              .then(function(response) {
                context.commit('orgLeaderBoardMutation', response.data);
                resolve(response.data);
              })
              .catch(
                function(err) {
                  reject(err);
                }
              )
          })
        }
    },
    getters: {
        quizWinnerGetters: state => state.quizWinnerState,
        quizContestGetters: state => state.quizContestState,
        contestPointsObtainedGetters: state => state.contestPointsObtainedState,
        contestLeaderBoardGetters: state => state.contestLeaderBoardState,
        schoolLeaderBoardGetters: state => state.schoolLeaderBoardState
    }
}
